import React from "react";
import { Phone, QrCode as QrIcon } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO_URL } from "../../data/content";
import { StoreButtons } from "./StoreButtons";
import { useLang } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();
  return (
    <footer id="kontakt" className="scroll-mt-24 bg-petrol text-cream">
      <div className="mx-auto max-w-7xl px-5 pt-20 sm:px-8">
        <div className="grid gap-10 rounded-[2.5rem] bg-terracotta p-8 sm:p-12 lg:grid-cols-[1.3fr_1fr] lg:items-center lg:p-14">
          <div>
            <h2 className="font-heading text-3xl font-extrabold tracking-tight text-white sm:text-4xl">
              {t.footer.ctaTitle}
            </h2>
            <p className="mt-3 max-w-lg text-lg text-white/85">
              {t.footer.ctaText}
            </p>
            <div className="mt-7">
              <StoreButtons idPrefix="footer" />
            </div>
          </div>
          <div className="flex items-center gap-5 rounded-3xl bg-white/10 p-6 backdrop-blur-sm">
            <div className="rounded-2xl bg-white p-3">
              <div
                data-testid="footer-qr-placeholder"
                className="flex h-[110px] w-[110px] flex-col items-center justify-center rounded-xl border-2 border-dashed border-petrol/20 text-petrol/40"
              >
                <QrIcon className="h-10 w-10" strokeWidth={1.5} />
                <span className="mt-1 text-[10px] font-bold">{t.footer.qrBadge}</span>
              </div>
            </div>
            <div>
              <p className="font-heading text-xl font-extrabold text-white">
                {t.footer.qrTitle}
              </p>
              <p className="mt-1 text-sm text-white/80">
                {t.footer.qrText}
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-5 py-16 sm:px-8">
        <div className="grid gap-10 md:grid-cols-2">
          <div>
            <div className="flex items-center gap-2.5">
              <img src={LOGO_URL} alt="WasGitsHüt? Logo" className="h-11 w-11 rounded-xl bg-cream object-contain p-0.5" />
              <span className="font-heading text-xl font-extrabold">
                WasGits<span className="text-terracotta">Hüt?</span>
              </span>
            </div>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-cream/60">
              {t.footer.tagline}
            </p>
          </div>

          <div>
            <p className="font-heading text-lg font-bold text-white">{t.footer.contact}</p>
            <a
              href="tel:+41565616762"
              data-testid="footer-phone-link"
              className="mt-4 inline-flex items-center gap-2 text-sm text-cream/70 transition-colors duration-200 hover:text-terracotta"
            >
              <Phone className="h-4 w-4 text-terracotta" />
              056 561 67 62
            </a>
            <nav className="mt-6 flex flex-col gap-2 text-sm text-cream/70">
              <a href="/#features" className="transition-colors duration-200 hover:text-terracotta">{t.nav.features}</a>
              <a href="/#so-gehts" className="transition-colors duration-200 hover:text-terracotta">{t.nav.how}</a>
              <Link to="/faq" className="transition-colors duration-200 hover:text-terracotta">{t.nav.faq}</Link>
              <Link to="/nutzerbedingungen" className="transition-colors duration-200 hover:text-terracotta">{t.nav.terms}</Link>
            </nav>
          </div>
        </div>

        <div className="mt-12 flex flex-col items-center justify-between gap-3 border-t border-white/10 pt-6 text-sm text-cream/50 sm:flex-row">
          <p>© {new Date().getFullYear()} Liberox GmbH. {t.footer.rights}</p>
          <div className="flex flex-wrap gap-x-6 gap-y-2">
            <Link to="/impressum" data-testid="footer-impressum-link" className="hover:text-terracotta">{t.nav.imprint}</Link>
            <Link to="/datenschutz" data-testid="footer-datenschutz-link" className="hover:text-terracotta">{t.nav.privacy}</Link>
            <Link to="/nutzerbedingungen" data-testid="footer-nutzerbedingungen-link" className="hover:text-terracotta">{t.nav.terms}</Link>
            <Link to="/faq" data-testid="footer-faq-link" className="hover:text-terracotta">{t.nav.faq}</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
